import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useVinControl } from 'app/shared/hooks/controls/useVinControl';

import { VinControlProps } from './VinControl.interfaces';

export default function VinControl(props: VinControlProps) {
  const {
    input,
    meta,
    meta: { touched, valid },
    label,
    subLabel,
    helperText,
    tooltip,
    width,
    defaultAlertStyle,
  } = props;

  const {
    focused,
    maxLength,
    handleBlur,
    handleChange,
    handleClick,
    onFocus,
  } = useVinControl(props);

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      subLabel={subLabel}
      helperText={helperText}
      floating
      floated={focused || UtilService.hasValue(input.value)}
      meta={meta}
      focused={focused}
      width={width}
      defaultAlertStyle={defaultAlertStyle}
    >
      <FormControl fullWidth>
        <TextField
          {...input}
          id={input.name}
          inputProps={{
            maxLength,
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          label={label}
          InputProps={{
            startAdornment: valid &&
              !focused &&
              UtilService.hasValue(input.value) && <DoneAdornment />,
          }}
          error={touched && !valid}
          variant={'outlined'}
          margin={'dense'}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
        />
      </FormControl>
    </ControlContainer>
  );
}
